import Page from './Page';
import CentreDetailsPage from './CentreDetailsPage';
import reducer from './reducer';

export const reducers = {
  CentreManager: reducer,
};

export default {
  Page,
  CentreDetailsPage,
  reducers,
};